import React, { useEffect, useState } from "react";
import { ButtonBase, TabsBase } from "@reusejs/react";
import { useRouter } from "next/router";
import { getAuctionEventById } from "services";
import EventForm from "./EventForm";

export default function EditEvent() {
  const router = useRouter();
  const { id } = router.query;
  const [event, setEvent] = useState<any>(null);

  useEffect(() => {
    if (id) {
      init(id);
    }
  }, [id]);

  const init = async (id: any) => {
    const data: any = await getAuctionEventById(id);
    setEvent(data);
  };

  return (
    <>
      <div className="flex justify-end mb-4">
        {event &&
          (event.status === "pending" ||
            event.status === "accepted" ||
            event.status === "live" ||
            event.status === "end") && (
            <ButtonBase
              variant="primary"
              type="submit"
              label={"Bidders"}
              onClick={() =>
                router.push(
                  `/dashboard/bidders?for_event=${event && event.listing_id}`
                )
              }
              buttonBaseClasses={{
                font: "text-base font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                width: "w-24",
                padding: "px-4 py-3",
              }}
            />
          )}
      </div>
      <div className="p-16 border rounded-lg">
        <EventForm mode={"edit"} prefillData={event} />
      </div>
    </>
  );
}
